import { map } from 'rxjs/operators';
import { useSharedValue, APP_EVENTS } from './shared-values';
import { useOnce } from './use-once';
export var useEvent = function (eventType, callback) {
    var stream = useSharedValue(APP_EVENTS, eventType)[0];
    useOnce(function () {
        var sub = stream.subscribe(function (event) { return callback(event.payload); });
        return function () { return sub.unsubscribe(); };
    });
};
export var useEventStream = function (eventType) {
    var stream = useSharedValue(APP_EVENTS, eventType)[0];
    return stream.pipe(map(function (event) { return event.payload; }));
};
export var useEventDispatch = function (event) {
    var stream = useSharedValue(APP_EVENTS, event)[0];
    return createEventDispatch(event, stream);
};
function createEventDispatch(event, stream) {
    return function (payload) {
        stream.next({
            type: event,
            payload: payload
        });
    };
}
//# sourceMappingURL=use-event.js.map